import React from 'react';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="footer py-3 mt-6">
      <div className="container-fluid">
        <div className="row">
          <div className="col-3">
            <b>Tribunal de Cuentas</b>
          </div>
          <div className="col-9 small">
            Dr. Luis Federico Leloir 309 - Neuquén<br />
            {year} - Desarrollado por Departamento Tecnologías de Información - Tribunal de Cuentas
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;